import { EntityService } from "@/model/service/entity-service"
import { RangeOffice } from "@/model/entity/range-office/range-office"

class ParcelShopService extends EntityService<RangeOffice> implements IRangeOfficeService {
  constructor() {
    super("range_office", RangeOffice)
  }
}

export interface IRangeOfficeService extends EntityService<RangeOffice> {
}

const service = new ParcelShopService()

export const rangeOfficeService = service
